<template>
  <div class="container-rules" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k005') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="text1">{{ $t('lang.BaseRules.k002') }}</div>

      <div class="title">{{ $t('lang.BaseRules.k003') }}</div>
      <div class="text1">1. {{ $t('lang.BaseRules.k004') }}</div>
      <div class="text1">2. {{ $t('lang.BaseRules.k005') }}</div>
      <div class="text1">3. {{ $t('lang.BaseRules.k006') }}</div>
      <div class="text1">4. {{ $t('lang.BaseRules.k007') }}</div>
      <br />

      <div class="title">{{ $t('lang.BaseRules.k008') }}</div>
      <div class="text1">1. {{ $t('lang.BaseRules.k009') }}</div>
      <div class="text1">2. {{ $t('lang.BaseRules.k010') }}</div>
      <div class="text1">3. {{ $t('lang.BaseRules.k011') }}</div>
      <div class="text1">4. {{ $t('lang.BaseRules.k012') }}</div>
      <div class="text1">5. {{ $t('lang.BaseRules.k013') }}</div>
      <div class="text1">6. {{ $t('lang.BaseRules.k014') }}</div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'

export default {
  data() {
    return {}
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-nav-block {
  background-color: #f9f9fb;
  .van-bar {
    ::v-deep .van-nav-bar__left .tit-left {
      font-family: var(--string-font);
      font-size: var(--fs-20);
      font-weight: var(--fw-900);
      line-height: var(--lh-title-24);
    }
  }
}
.container-rules {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    padding: 20px 16px;
    color: #666666;
    line-height: var(--lh-body-20);
    .title {
      color: #000;
      margin-bottom: 12px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-700);
      line-height: var(--lh-body-20);
    }
    .text1 {
      width: 100%;
      padding: 0 5px;
      color: #333333;
      margin-bottom: 12px;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-20);
    }
  }
}
</style>
